export { default as AppVersionList } from "./List";
export { default as AppVersionEdit } from "./Edit";

export const API_URL = '/api/appversion';
export const TITLE = 'App Version';